﻿(() => {
  const inputRangeComponents = document.querySelectorAll<HTMLInputElement>("[data-js-name='input-range']");

  inputRangeComponents.forEach(input => {
    input.addEventListener("input", (event) => {
      const targetInputElement = (event.target as HTMLInputElement)
      const displayValue = targetInputElement.parentNode?.querySelector<HTMLElement>("[data-js-name='display-value']");
      if (displayValue) {
        displayValue.textContent = targetInputElement.value;

        let progress: number;

        switch (targetInputElement.value) {
          case targetInputElement.min:
            progress = 0;
            break;
          case targetInputElement.max:
            progress = 100;
            break;
          default:
            progress = 100 / (parseInt(targetInputElement.max) - parseInt(targetInputElement.min) / parseInt(targetInputElement.step)) * (parseInt(targetInputElement.value) - 1);
            break;
        }

        targetInputElement.style.background = `linear-gradient(to right, #00263E ${progress}%, transparent ${progress}%)`;
      }
    });
  });
})();